// extracted by mini-css-extract-plugin
export default {"ring":"ProgressRing_ring__TbCVn","value":"ProgressRing_value__Xp1vJ","center":"ProgressRing_center__xwWU7"};